import { Link } from "react-router-dom";
import { CarFront, Wrench, PackageCheck, FileClock } from "lucide-react";
import { useFetch } from "@/lib/useFetch";
import { t } from "@/i18n";

export function JobCounts() {
  const { data } = useFetch("/garage/job-counts");
  if (!data) return null;
  const c = data.counts;
  const tiles = [
    { k: "received", n: c.received + c.inspecting + c.awaiting_approval, to: "/pro/jobs?status=received,inspecting,awaiting_approval", icon: CarFront },
    { k: "in_progress", n: c.approved + c.in_progress, to: "/pro/jobs?status=approved,in_progress", icon: Wrench },
    { k: "ready", n: c.ready, to: "/pro/jobs?status=ready", icon: PackageCheck },
    { k: "quotes_pending", n: data.quotes_pending, to: "/pro/quotes?status=sent", icon: FileClock },
  ];
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4" data-testid="job-counts">
      {tiles.map(({ k, n, to, icon: Icon }) => (
        <Link key={k} to={to} data-testid={`job-count-${k}`} className="gf-card group flex items-center justify-between p-5 transition-shadow duration-150 hover:shadow-md">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">{t(`jobs.counts.${k}`)}</p>
            <p className="mt-1 font-display text-4xl font-extrabold text-slate-900" data-testid={`job-count-${k}-value`}>{n}</p>
          </div>
          <Icon className="h-6 w-6 text-teal-600 transition-transform duration-150 group-hover:scale-110" />
        </Link>
      ))}
    </div>
  );
}
